export const exchange = "exchange-help";
export const tradingPair = "tradingpair-help";
export const strategy = "strategy-help";
export const initFund = "initFund-help";
export const baseOrder =
  "baseOrder-help";
export const baseOrderType =
  "";
export const extraOrder =
  "";
export const tradingFrequency =
  "";
export const entryCondition =
  "";
export const entryConditionExitBot =
  "";
export const entryConditionPriceBot =
  "";
export const exitConditionPriceBot =
  "";
export const exitCondition =
  "";
export const slFixed =
  "";
export const slVariable =
  "";
export const dcaMartingale =
  " ";
export const trailingRSILong =
  "";
export const trailingRSIShort =
  ".";
export const trailingSRSILong =
  "";
export const trailingSRSIShort =
  "";
export const dcaEntry =
  "";
export const dcaExit =
  "";
export const gridMidPrice = ""
